<template>
  <section class="min-h-screen flex items-stretch text-white bg-[#F7F7F7]">
    <!-- Side Menu -->
    <div class="hidden md:flex flex-col justify-between bg-[#090446] text-white w-1/6 p-4">
      <!-- Top Menu -->
      <div class="sticky top-0 bg-[#090446] p-4 z-20">
        <div>
          <p class="text-lg font-semibold">Total Progress: {{ progressDetail.totalAnswers1+progressDetail.totalAnswers2+progressDetail.totalAnswers3 }}/{{ progressDetail.totalQuestions1+progressDetail.totalQuestions2+progressDetail.totalQuestions3 }}</p>
          <p class="text-lg font-semibold">Part - 1 : {{ progressDetail.totalAnswers1 }}/{{ progressDetail.totalQuestions1 }}</p>
          <p class="text-lg font-semibold">Part - 2: {{ progressDetail.totalAnswers2 }}/{{ progressDetail.totalQuestions2 }}</p>
          <p class="text-lg font-semibold">Part - 3: {{ progressDetail.totalAnswers3 }}/{{ progressDetail.totalQuestions3 }}</p>
          <div class="w-full bg-gray-200 rounded-full h-2.5 mt-2">
            <div class="bg-[#ab064e] h-2.5 rounded-full" :style="{ width: ((progressDetail.totalAnswers1+progressDetail.totalAnswers2+progressDetail.totalAnswers3) / (progressDetail.totalQuestions1+progressDetail.totalQuestions2+progressDetail.totalQuestions3)) * 100 + '%' }"></div>
          </div>
        </div>
      </div>

      <!-- Bottom Menu -->
      <div class="mt-auto">
        <router-link to="/privacy-policy" class="text-white hover:text-[#ab064e]">
          Privacy Policy
        </router-link>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex-1 flex flex-col items-center py-6 md:px-16 px-4 z-0">
      <!-- Instructions Card -->
      <div id="instructions-card" class="bg-white text-black p-6 rounded-lg shadow-lg mb-6 w-full lg:w-3/4">
        <div class="flex items-center justify-center mb-4">
          <a href="#" class="flex items-center">
            <img src="../assets/images/logo.png" class="h-24" alt="Logo" />
          </a>
        </div>
        <h2 class="text-2xl font-bold mb-4 text-center text-[#090446]">Survey Instructions</h2>
        <p class="text-lg">Below are some statements that describe behavior or experiences individuals have at work when interacting with others.</p>
        <p class="text-lg mt-4">For each statement below, please consider your interactions with colleagues in your current or previous role. Please indicate how well you feel the statement describes you and your experiences with others using a scale from 0-10, where 10 means "describes me extremely well" and 0 means "does not describe me at all." You may use a 0, a 10, or any number in between.</p>
        <p class="text-lg mt-4">It is possible that all statements describe you, but most people only consider some of these items to be most true for them and others less so. Please do not rate all items as high, medium, or low.</p>
      </div>

      <!-- Questions Card -->
      <div id="questions-card" class="bg-white text-black p-6 rounded-lg shadow-lg w-full lg:w-3/4">
        <h2 class="text-2xl font-bold mb-4 text-center text-[#090446]">Survey Questions</h2>
        <div v-for="(question, index) in questions" :key="question.question_id" class="mb-6">
          <p class="text-xl font-semibold">{{ index + 1 }}. {{ question.question }}</p>
          <div class="flex justify-center text-sm text-gray-600 mt-2">
            <span class="text-[#0A0446] strongly-text mx-2">Does not describe me/my experience at all</span>
            <div class="flex justify-center mt-2">
              <div class="flex space-x-2">
                <label v-for="num in 10" :key="num" class="flex flex-col items-center">
                  <input
                    type="radio"
                    :name="'question_' + question.question_id"
                    :value="num"
                    class="hidden"
                    @change="handleAnswerChange(question.question_id, num)"
                  />
                  <span
                    class="block w-12 h-12 border border-gray-300 rounded-full text-black text-center leading-[48px] cursor-pointer transition-all duration-300 ease-in-out"
                    :class="{'bg-[#0A0446] text-white': selectedAnswers[question.question_id] === num, 'hover:bg-gray-200': selectedAnswers[question.question_id] !== num}"
                  >
                    {{ num }}
                  </span>
                </label>
              </div>
            </div>
            <span class="text-[#0A0446] strongly-text mx-2">Describes me/my experience extremely well</span>
          </div>
        </div>

        <!-- Continue Button -->
        <div class="flex justify-center mt-8" v-if="questions.length > 0">
          <button class="relative inline-flex items-center justify-center px-16 py-3 bg-[#0A0446] text-white rounded-lg hover:bg-[#0A0446] transition-all duration-300 h-10" @click="continueToNextPage">
            <svg v-if="isLoading" class="animate-spin h-5 w-5 text-white absolute" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
            </svg>
            <span v-else>Submit Survey</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import Swal from 'sweetalert2'
import Api from '../router/api'
import AppMixin from '../mixins/AppMixin'

export default {
  name: 'NonEmployeeSurveyThree',
  data() {
    return {
      url: '',
      questions: [],
      selectedAnswers: {},
      progressDetail: {
        totalQuestions1: 0,
        totalQuestions2: 0,
        totalQuestions3: 0,
        totalAnswers1: 0,
        totalAnswers2: 0,
        totalAnswers3: 0,
      },
      isLoading: 0
    }
  },
  mounted() {
    let urlToken = this.$route.fullPath.split('/')[2]
    this.url = urlToken
    this.getProgressBarDetail(this.url);
    this.getQuestions(this.url)
  },
  computed: {
    progress() {
      // Calculate the progress percentage
      return (Object.keys(this.selectedAnswers).length / this.questions.length) * 100;
    }
  },
  methods: {
    getQuestions(url) {
      Api.getSectionThreeQuestions(url).then(response => {
        this.questions = response.data.res;
        this.questions.forEach(question => {
          this.$set(this.selectedAnswers, question.question_id, question.response);
        });
      });
    },
    getProgressBarDetail(url) {
        Api.getProgressBarDetail(url).then(response => {
            this.progressDetail.totalQuestions1 = response.data.res.totalQuestions1;
            this.progressDetail.totalQuestions2 = response.data.res.totalQuestions2;
            this.progressDetail.totalQuestions3 = response.data.res.totalQuestions3;
            this.progressDetail.totalAnswers1 = response.data.res.totalAnswers1;
            this.progressDetail.totalAnswers2 = response.data.res.totalAnswers2;
            this.progressDetail.totalAnswers3 = response.data.res.totalAnswers3;
        });
    },
    handleAnswerChange(questionId, answer) {
      this.$set(this.selectedAnswers, questionId, answer);
      Api.saveQuestionResponse({ question_id: questionId, response: answer, token: this.url })
      this.getProgressBarDetail(this.url);
    },
    continueToNextPage() {
      this.isLoading = 1;
      Api.submitSectionThree(this.url).then(response => {
        if(response.data.res < 8){
          this.isLoading = 0;
            this.$swal({
                icon: "warning",
                title: "Warning",
                text: "Please answer all the questions.",
                showConfirmButton: true,
                confirmButtonColor: '#0A0446'
            })
        }else{
            Api.NonEmployeeSurveySubmit(this.url).then(response => {
                this.$router.push(`/survey-complete/${this.url}`);
            });
        }
      });
    }
  }
}
</script>

<style scoped>
.strongly-text{
    align-items: center;
    justify-content: center;
    display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/NonEmployeeSurveyThree.vue